module.exports = __webpack_public_path__ + "img/noq-map-pin-normal.e2629b64.svg";